define('GameDayCore/main',['require','exports','module','jquery','datasource-manager/datasource-manager','message-service/message-service','extant/extant','./GDControl/GameModelLocator/GameModelLocator','./GDModel/enums/events/EventTypes','gameday-index-url-hasher/enums/HashEvents','./GDModel/enums/datasources/Datasources','./GDControl/SubscriptionManager/SubscriptionManager','./GDControl/TfsManager/TfsManager','./GDControl/advertising/MidInningGamesManager','./GDControl/advertising/PageVisibilityManager','./GDUtil/resources/DataSourceSelector','gameday-index-url-hasher/UrlHasher','./GDUtil/window/WindowBridge','./GDUtil/window/Logg','gameday-index-enums/enums/baseball/GIDDecoder','./GDUtil/resources/GDConfig'],function(require,exports,module) {
    var $ = require("jquery"),
        DatasourceManager = require("datasource-manager/datasource-manager"),
        MessageService = require("message-service/message-service"),
        extant = require("extant/extant"),
        GameModelLocator = require("./GDControl/GameModelLocator/GameModelLocator"),
        EventTypes = require("./GDModel/enums/events/EventTypes"),
		HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
        Datasources = require("./GDModel/enums/datasources/Datasources"),
        SubscriptionManager = require("./GDControl/SubscriptionManager/SubscriptionManager"),
        TfsManager = require("./GDControl/TfsManager/TfsManager"),
        MidInningGamesManager = require("./GDControl/advertising/MidInningGamesManager"),
        PageVisibilityManager = require("./GDControl/advertising/PageVisibilityManager"),
        DatasourceSelector = require("./GDUtil/resources/DataSourceSelector"),
        // GDAppTracking = require("./GDUtil/tracking/GDAppTracking"),
        UrlHasher = require("gameday-index-url-hasher/UrlHasher"),
        WindowBridge = require("./GDUtil/window/WindowBridge"),
        logg = require("./GDUtil/window/Logg"),
        GameId = require("gameday-index-enums/enums/baseball/GIDDecoder"),
        GDConfig = require("./GDUtil/resources/GDConfig");

    var instance;

	function GameDayCore() {
		// I am a singleton. look at me go.
	}

	GameDayCore.prototype = {

        GDConfig: GDConfig,
        /**
         * Function init
         * @param gid {String} gid game id to run with (optional if game value is in urlHash
         * @param opts {Object} opts various config settings that can be passed in
         *
         * kicks everything off (of course)
         */
        init: function (gid, opts) {
            var hashParams = UrlHasher.getHashParams();

            // if no config options were passed in, try the hash params
            // if both were passed in, hash > hard coded config
            if (!extant(opts)) {
                opts = hashParams;
            }
            else if (extant(hashParams)) {
                $.extend(opts, hashParams);
            }

            GDConfig.initProps = opts;

            // if logging is called for in the options, set up Curveball debugging
            if (extant(opts.logging)) {
                GDConfig.log = opts.logging || 'none';
                logg.setLevel(GDConfig.log); //{level: 'none', ns: "GDC"}
            }

            // override the hard coded gid if game is in the urlHash
            if (extant(opts.game) && opts.game!=="") {
                var useme = new GameId(opts.game);
                gid = useme.gid_path
            }

			if (extant(opts.testVideoAds)) {
				GDConfig.testVideoAds = opts.testVideoAds;
			}

            // build the start state hash
            UrlHasher.setInitParams(opts, opts.game || gid);
            TfsManager.init(opts.tfsStartTime || opts.tfsStart || opts.tfs || null, opts.ffwd || 10, !extant(opts.tfsHold));

            // if options contain supported video declaration override the defaults
            if (extant(opts.supportedVideo) || extant(opts.playbackScenarios) || extant(opts.videoFormats)) {
                GDConfig.supportedVideo = [].concat(opts.supportedVideo || opts.playbackScenarios || opts.videoFormats);
            }

            if (extant(opts.liveLookin)) {
                this.setHashParams({ game_tab: "videos" });
            }

            // if passive mode is called for store it as a game heartbeat will not be created
            if (extant(opts.passiveMode) && opts.passiveMode === true) {
                GDConfig.passiveMode = true;
            }

            // assign the Datasources to datasource-manager ...
            DatasourceSelector.addSources(opts.dataOverrides || {});

            // this will set Datasources to be loaded (undefined gets the whole shebang)
            SubscriptionManager.subscribe(opts.dataSources);
            // if passed this eliminates any data sources you might want to force off
            if (extant(opts.excludes)) {
                SubscriptionManager.unsubscribe(opts.excludes);
            }

            // if some default event listeners were passed in, assign those out...
            if (extant(opts.listeners)) {
                for (var i = 0, len = opts.listeners.length; i < len; i++) {
                    this.addListener(opts.listeners[i].event, opts.listeners[i].handler);
                }
            }

            // add a listener of our own
            MessageService.addListener(EventTypes.GAME_INITIALIZED, this.initView);
			MessageService.addListener(HashEvents.GAME_ID_CHANGED, function(payload) {
				GameModelLocator.getGame(payload);
			});

            // start the process!
            GameModelLocator.getGame(gid, opts);
        },

        /**
         * Function start
         * @param opts {Object} this object is generated internally
         *
         *  you would think this was init, but it's start. start happens after init
         */
        start: function (opts) {
            var currentGame = GameModelLocator.getCurrentGame();
            // hold yr horses if there's no game ready, this will get called again when there is
            if (!extant(currentGame) || !currentGame.initialized) {
                logg.log("the game is not yet ready, this function will be recalled when it is...");
                return;
            }

            // set a var for a function in another silo
            var checkState = UrlHasher.checkState;
            logg.log("attempting start...");

            // assign some values in the config...
            GDConfig.i18n = GDConfig.dictionary[GDConfig.lang] ? function (code) {
                return GDConfig.dic;
            } : function (code) {
                return code;
            };

            // assign a listener to the urlHash (make sure there isn't one already, first)
            WindowBridge.addListener('hashchange', checkState);
            // do a first pass of the listener fucntion so we have a clean slate
            checkState();
            // return the hash params as they are currently
            return UrlHasher.getCachedParams();
        },

        /**
         * function initView
         * @param evt {Object} event data object
         * @param payload {*} payload whatever was passed along with the event
         *
         * this calls start function after the min required files are ready in the model
         */
        initView: function (evt, payload) {
            // gimme a mid-inning game Manager
            MidInningGamesManager.init();
            
            // wake up the window bridge
            WindowBridge.init();

            // prep tracking
            // GDAppTracking.init();

            // dispense with the listener amd spin 'er up
            MessageService.removeListener(EventTypes.GAME_INITIALIZED, instance.initView);
            instance.start();
        },

        /**
         * function getGameData
         * @param flavor {*} string, array, object or comma delineated list as string of which data point is needed
         * @retuns {Object} modelVO with each requested data point as an attribute containing the VO for that datasource
         *
         * the main access point for any already loaded data, passing no argument returns the sum total of all game data
         * the model locator will deliver only the data of the 'active' game, if there is one, so no game id is needed
         */
        getGameData: function(flavor) {
            return GameModelLocator.getGameData(flavor);
        },

        /**
         * function requestGameData
         * @param flavor {*} string, array, object or comma delineated list as string of which data point is needed
         * @param params {Object} optional collection of name-value pairs to add to the Load call
         * @returns {String} unique 1-time event id that data will be dispatched over once Load completed
         *
         * the function to call for any data point that is not on the heartbeat (ie, loaded on the regular)
         * this will examine each source to see if it is expired, if not it will simply use the current value
         * also if the data Load fails, it will return the current value (which could conceivably be null)
         * once all data is ready, it will dispatch an event with the unique ID returned from this function
         */
        requestGameData: function(flavor, params) {
            return GameModelLocator.requestGameData(flavor, params);
        },

        /**
         * function getCurrent
         * @returns {Object} returns GameItem object for the active game if there is one
         */
        getCurrent: function() {
            return GameModelLocator.getCurrentGame();
        },

		switchGame: function(payload, evt) {
			GameModelLocator.switchGame(payload);
		},

        /**
         *  Function addListener
         *  @param eventName {String} event to listen to
         *  @param handler {Function} scoped function to act as event handler
         *
         *  central location to add listeners to the Curveball event dispatcher
         */
        addListener: function (eventName, handler) {
            logg.log("subscribing to event: ", eventName);
            MessageService.addListener.call(this,eventName, handler);
        },

        /**
         * Function removeListener()
         * @param eventName {String} the event to no longer listen to
         * @param handler {Function} scoped function to remove from the handler list
         *
         * centralized location to remove listeners from the Curveball event dispatcher
         */
        removeListener: function (eventName, handler) {
            MessageService.removeListener.call(this,eventName, handler);
        },

        /**
         * Function getCachedParams
         * @param param {Object} mix-in object
         * @returns {Object} name-value pairs
         *
         * retriever for the cahced params, which frankly i don't know how they're different from the params
         */
        getCachedParams: function (param) {
            return UrlHasher.getCachedParams(param);
        },

        /**
         * Function getHashParams
         * @param param {Object} mix-in object
         * @returns {Object} name-value pairs from the hash params
         *
         * retriever for the hash params as they are in the url
         */
        getHashParams: function (param) {
            return UrlHasher.getHashParams(param);
        },

        /**
         * Function setHashParams
         * @param param {Object} mix-in object to be added to the hash params
         */
        setHashParams: function (param) {
            UrlHasher.setHashParams(param);
        },

        /**
         * Function removeHashParam
         * @param param {String} name of param to be removed
         */
        removeHashParam: function (param) {
            UrlHasher.removeHashParam(param);
        },

        /**
         * Function loadAtTfsPoint
         * @param $timecode {String} the time at which to Load
         *
         * this will set the time code to the passed value then Execute a Load of all requested data in 'passive' mode
         */
        loadAtTfsPoint: function ($timecode) {
            TfsManager.setTimecode($timecode);
            if (GDConfig.passiveMode) {
                this.getCurrent().executePassiveLoad();
            }
        },

        /**
         * Function beginCommercialBreak
         */
        beginCommericalBreak: function () {
            MessageService.publish(EventTypes.BEGIN_COMMERCIAL_BREAK);
        },

        /**
         * Function endCommercialBreak
         */
        endCommercialBreak: function () {
            MessageService.publish(EventTypes.END_COMMERCIAL_BREAK);
        },

        /**
         * Function handleCommercialCompanionAd
         * @param payload {Object}
         */
        handleCommercialCompanionAd: function (payload) {

            MessageService.publish(EventTypes.COMMERCIAL_COMPANION_RECEIVED, payload);
            /*var statRe = Datasources.STATIC_RESOURCES,
                tude = this.getGameData(statRe)[statRe].getAuditude(),
                compBan = (extant(tude)) ? tude.jsCompanionFunction : undefined,
                defaultComp = (extant(tude)) ? tude.jsDefaultCompanionFunction : undefined;

            if (extant(payload)) {
                var ads = escape(JSON.stringify(payload));
                WindowBridge.dispatchMessage("updateCompanionAd~" + ads);
            } else if (defaultComp) {
                WindowBridge.dispatchMessage("defaultCompanionAd");
            }*/

        },

		/**
		 * Function swiffyComplete
		 * exposes function to window scope for functions bluntly called by swiffys
		 */
		swiffyComplete: function() {
			MessageService.publish(EventTypes.SWIFFY_COMPLETE);
		}
	};
    
	return instance = new GameDayCore();
});
define('GameDayCore', ['GameDayCore/main'], function (main) { return main; });

